import React, {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import FeedIcon from "@mui/icons-material/Feed";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import EditNoteIcon from "@mui/icons-material/EditNote";
import BallotIcon from "@mui/icons-material/Ballot";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AddBoxIcon from "@mui/icons-material/AddBox";
import InfoIcon from '@mui/icons-material/Info';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import DomainAddIcon from '@mui/icons-material/DomainAdd';
import s from "./Nav.module.scss";

export const MenuItem = ({item}) => {
    const [toggle, setToggle] = useState(false);
    const {pathname} = useLocation();

    useEffect(() => {
        if(pathname?.includes(item.url)) {
            setToggle(true);
        }
    }, [pathname]);

    const iconMap = {
        HomeIcon: <HomeIcon fontSize="large" />,
        FeedIcon: <FeedIcon fontSize="large" />,
        RecentActorsIcon: <RecentActorsIcon fontSize="large" />,
        ContactEmergencyIcon: <ContactEmergencyIcon fontSize="large" />,
        QrCodeScannerIcon: <QrCodeScannerIcon fontSize="large" />,
        EditNoteIcon: <EditNoteIcon fontSize="large" />,
        BallotIcon: <BallotIcon fontSize="large" />,
        AssignmentIndIcon: <AssignmentIndIcon fontSize="large" />,
        AddBoxIcon: <AddBoxIcon fontSize="large" />,
        InfoIcon: <InfoIcon fontSize="large" />,
        SummarizeIcon: <SummarizeIcon fontSize="large" />,
        ReceiptLongIcon: <ReceiptLongIcon fontSize="large" />,
        LeaderboardIcon: <LeaderboardIcon fontSize="large" />,
        CorporateFareIcon: <CorporateFareIcon fontSize="large" />,
        DomainAddIcon: <DomainAddIcon fontSize="large" />
    };

    const renderIcon = (iconName) => {
        return iconMap[iconName] || null;
    };

    return (
        <li className={s.item}>
            <div className={s.item__wrapper}>
                {renderIcon(item?.cover?.conversions?.icon)}
            </div>
            {!!item.children?.length ? (
                <div>
                    <p onClick={() => setToggle(prev => !prev)}>
                        <span style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                            {item?.cover?.original && <img src={item?.cover?.original} style={{marginRight: 10}} alt="Icon menu"/>}
                            <span className={s.title}>{item.title}</span>
                        </span>
                    </p>
                    {toggle && (
                        <ul>
                            {item.children.map(child => (
                                <MenuItem key={child.id} item={child}/>
                            ))}
                        </ul>
                    )}
                </div>
            ) : item?.role
                ? JSON.parse(localStorage.getItem('roles'))?.includes('super-admin') &&
                <Link to={item.url} style={{fontWeight: pathname?.includes(item.url) ? 700 : 400}}>
                    {item?.cover?.original && <img src={item?.cover?.original} style={{marginRight: 10}} alt="Icon menu"/>}
                    <span className={s.title}>{item.title}</span>
                </Link>
                : <Link to={item.url} style={{fontWeight: pathname?.includes(item.url) ? 700 : 400}}>
                    {item?.cover?.original && <img src={item?.cover?.original} style={{marginRight: 10}} alt="Icon menu"/>}
                    <span className={s.title}>{item.title}</span>
                </Link>}
        </li>
    );
}